import { convertToApiURL } from '../common/searchRequestUtils.js';


export const fetchProjects = (url, success, error) => $.ajax({
    type: 'get',
    url: convertToApiURL(url),
    cache: true,
    dataType: 'json',
    success: success,
    error: (xhr, status) => {
        // It seems like we can get false positives of parsererror
        if (status !== 'parsererror') {
            error(xhr, status);
        }
    },
});
